import { useSelectTheme } from "../../store";
import { RIF } from "../../lib";
import { CSSProperties } from "react";

export interface DropdownMenuProps {
  dropped: boolean;
  options: ({
    text: string;
    textColor?: string;
    description?: string;
    img?: any;
    alt?: string;
    onClick: () => void;
  } | null)[];
  parentCSS?: CSSProperties;
}

export const DropdownMenu = (props: DropdownMenuProps) => {
  const { color } = useSelectTheme();
  const { dropped, options, parentCSS } = props;
  const visibleOptions = options.flatMap((option) => (option ? [option] : []));

  return (
    <div
      css={{
        minWidth: "160px",
        background: color.white,
        border: `1px solid ${color.grey_160}`,
        borderRadius: "5px",
        display: `${dropped ? "flex" : "none"}`,
        flexDirection: "column",
        justifyContent: "space-between",
        cursor: "auto",
        padding: "8px 0",
        boxShadow: "0px 4px 10px 1px #68686840",
        zIndex: 999,
        position: "absolute",
        ...parentCSS,
      }}
    >
      {visibleOptions.map((option, index) => (
        <DropdownSelection
          key={index}
          onClick={option.onClick}
          img={option.img}
          alt={option.alt}
          text={option.text}
          description={option.description}
          textColor={option.textColor}
        />
      ))}
    </div>
  );
};

const DropdownSelection = (props: {
  img?: any;
  text: string;
  textColor?: string;
  description?: string;
  alt?: string;
  onClick: () => void;
}) => {
  const { fontWeight, color } = useSelectTheme();
  const { img, text, description, textColor, alt, onClick } = props;
  return (
    <div
      onClick={onClick}
      css={{
        cursor: "pointer",
        display: "flex",
        padding: "8px 16px",
        alignItems: "center",
        minWidth: "fit-content",
        ":hover": {
          background: "rgba(156, 158, 174, 0.05)",
        },
      }}
    >
      {RIF(img, (img) => (
        <img src={img} width="24" alt={alt ?? ""} css={{ marginRight: "7px" }} />
      ))}
      <div
        css={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          gap: "4px",
        }}
      >
        <span
          css={{
            fontWeight: fontWeight.bold,
            color: textColor ?? color.black,
            cursor: "pointer",
            whiteSpace: "nowrap",
          }}
        >
          {text}
        </span>
        {RIF(description, (description) => (
          <span
            css={{
              fontWeight: fontWeight.medium,
              color: color.textIcon.greyIcon,
              cursor: "pointer",
            }}
          >
            {description}
          </span>
        ))}
      </div>
    </div>
  );
};
